module.exports = __webpack_public_path__ + "static/media/lung_cancer-gray.8e47a856.svg";